import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('groq'),
  titleToNamespace: true,
  avatarPath: avatars.groq,
  logoPath: logos.groq
});
